import React, { useEffect, useCallback, useState } from "react"

import { withStyles } from "@material-ui/styles"
import { Theme, Zoom } from "@material-ui/core"
import Tooltip from "@material-ui/core/Tooltip"
import ClickAwayListener from "@material-ui/core/ClickAwayListener"

import close_icon from "../../images/icons/icon_closeV2.svg"
import hint_icon from "../../images/icons/icon_hintV2.svg"

import * as styles from "./itemTooltip.module.scss"
import { ItemTooltipProps } from "./types"
import { DLClickEventExtended } from "../../helpers/WatcherDL/DLEvents"
import scrollToPersonalForm from "../../helpers/scrollToPersonalForm"

export function ItemTooltipAbPkw({
  hintText,
  icon = hint_icon,
  children,
  showHint = true,
}: ItemTooltipProps) {
  const [open, setOpen] = useState(false)

  const handleTooltipClose = useCallback(() => {
    setOpen(false)
  }, [])

  useEffect(() => {
    window.addEventListener("scroll", handleTooltipClose)
    return () => {
      window.removeEventListener("scroll", handleTooltipClose)
    }
  }, [handleTooltipClose])

  const handleTooltipOpen = () => {
    if (showHint) setOpen(true)
    DLClickEventExtended({
      name: "Tooltip",
      eventAction: "Халва.Десятка в подарок",
      placement: "header",
    })
  }

  const HtmlTooltip = withStyles((theme: Theme) => ({
    tooltip: {
      marginTop: 0,
      color: " rgba(41, 41, 41, 1)",
      position: "absolute",
      left: -158,
      pointerEvents: "auto",
      cursor: "default",
      padding: "12px 16px",
      background: "rgba(249, 249, 249, 1)",
      boxSizing: "border-box",
      boxShadow: "0px 4px 24px rgba(0, 0, 0, 0.12)",
      borderRadius: 12,
      width: 270,
      transition: "0.5s all",
      fontWeight: 400,
      [theme.breakpoints.up("sm")]: {
        marginTop: 10,
        left: -180,
      },
      [theme.breakpoints.up("md")]: {
        padding: 13,
        left: -207,
        width: 330,
      },
    },
  }))(Tooltip)
  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <HtmlTooltip
          PopperProps={{
            disablePortal: false,
          }}
          onClose={handleTooltipOpen}
          placement="bottom-start"
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={
            <div className={styles.hintContainer}>
              <div className={styles.hintModalAB}>{hintText}</div>
              <div className={styles.close} onClick={handleTooltipClose} aria-hidden="true">
                <img src={close_icon} alt="close" />
              </div>
            </div>
          }
          TransitionComponent={Zoom}
        >
          <div className={styles.wrapperChildren}>
            <div
              className={styles.childrenTextAbPkw}
              onClick={() => {
                DLClickEventExtended({
                  name: "Tooltip",
                  eventAction: "Халва.Десятка в подарок",
                  placement: "header",
                })
                scrollToPersonalForm()
              }}
              aria-hidden="true"
            >
              {children}
            </div>
            <button
              type="button"
              onClick={handleTooltipOpen}
              className={styles.childrenButtonAbPkw}
            >
              <img src={icon} alt="close" className={styles.childrenImg} />
            </button>
          </div>
        </HtmlTooltip>
      </div>
    </ClickAwayListener>
  )
}
